/*
 * @Author: Json Chen
 * @Date: 2021-06-23 09:34:36
 * @LastEditTime: 2021-07-09 10:25:54
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/LinkLibrary/Components/UrlForm.tsx
 */

import React from 'react';
import { Input, Form } from 'antd';
import { useHistory } from 'react-router';
import { useRequest } from 'ahooks';
import { searchMiniOptions } from '@/src/request/settings/linkLibrary';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipTitle,
  TooltipContent,
} from '@/src/components/GlobalTooltip/WhiteBackgroundTooltip';
import {
  QuestionCircleFilled,
  InfoCircleOutlined,
  CaretDownOutlined,
} from '@ant-design/icons';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import styles from '../style.module.less';
import { LinkType } from '../type';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const UrlForm = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const history = useHistory();
  const [search, setSearch] = React.useState<string>('');
  const { loading, data: optionsList = [] } = useRequest(
    () => {
      return searchMiniOptions(search);
    },
    {
      refreshDeps: [search],
      debounceInterval: 500,
      throttleInterval: 500,
    },
  );
  const toLinkLibraryMini = () => {
    history.push(`/settings/linkLibrary?tab=${LinkType.MiniProgram}`);
  };
  return (
    <div className={styles.linkTypeUrlContent}>
      <Form.Item
        name={['url']}
        label={
          <div className={styles.linkTypeUrlContentLabel}>
            <span className={styles.linkTypeUrlContentLabelTitle}>
              {getI18n('general.uRL')}*
            </span>
            <span className={styles.linkTypeUrlContentLabelRules}>
              {getI18n('storeLinkLibrary.detail.urlTip')}
            </span>
          </div>
        }
        rules={[
          { required: true },
          {
            //校验验手机号格式
            validator: async (_, value) => {
              const reg =
                /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
              if (value) {
                if (!reg.test(value)) {
                  throw new Error(`Invalid URL.`);
                }
              }
            },
          },
        ]}>
        <Input size='large' placeholder={'https://'} maxLength={200} />
      </Form.Item>
      <Form.Item
        name={['relatedMiniProgram']}
        label={
          <div className={styles.linkTypeUrlContentLinkMiniLabel}>
            <span className={styles.linkTypeUrlContentLinkMiniLabelTitle}>
              {getI18n('storeLinkLibrary.detail.linkedMiniProgram')}
            </span>
            <WhiteBackgroundTooltip
              title={
                <TooltipContainer>
                  <TooltipTitle>
                    {getI18n('storeLinkLibrary.detail.linkedMiniProgram')}
                  </TooltipTitle>
                  <TooltipContent>
                    {getI18n('storeLinkLibrary.detail.linkedTip')}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='right' //overlayClassName
            >
              <QuestionCircleFilled />
            </WhiteBackgroundTooltip>
          </div>
        }
        extra={
          <div className={styles.linkTypeUrlContentLinkMiniExtra}>
            <InfoCircleOutlined />
            <span className={styles.linkTypeUrlContentLinkMiniExtraIcon}>
              {getI18n('storeLinkLibrary.detail.linkTipFront')}
              <span
                className={styles.linkTypeUrlContentLinkMiniExtraMini}
                onClick={toLinkLibraryMini}>
                {getI18n('general.miniProgram')}
              </span>
              {getI18n('storeLinkLibrary.detail.linkTipFront2')}
            </span>
          </div>
        }>
        <SelectObjectAsValue
          showSearch
          objectAsValue
          loading={loading}
          onSearch={setSearch}
          options={optionsList}
          placeholder={replaceI18nVariables(
            getI18n('general.selectAndSearchPlaceholder'),
            '…',
          )}
          labelKey={'title'}
          valueKey={'uuid'}
          size='large'
          notFoundContent={
            <div className={styles.linkTypeUrlContentLinkMiniNoResult}>
              {getI18n('storeLinkLibrary.detail.noResult')}
            </div>
          }
          suffixIcon={<CaretDownOutlined className={styles.selectIcon} />}
          style={{
            width: '100%',
          }}></SelectObjectAsValue>
      </Form.Item>
    </div>
  );
};

export default UrlForm;
